import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useContextGuard from '~/common/hooks/useContextGuard';
import { getFleets, selectAllFleets } from '~/features/fleets/fleetsSlice';

/**
 * Hook to fetch and select fleets for catalog features, session-aware.
 * Returns fleets as [{ fleetId, name }].
 */
export function useCatalogFleets() {
  const { contextData } = useContextGuard();
  const dispatch = useDispatch();

  // Select fleets from Redux
  const allFleets = useSelector(selectAllFleets);

  // Fetch fleets for the current organization/session
  useEffect(() => {
    const organizationId = contextData?.organizationsId;
    if (organizationId && (!allFleets || allFleets.length === 0)) {
      dispatch(
        getFleets({
          organizationsId: organizationId,
        })
      );
    }
  }, [dispatch, allFleets, contextData]);

  // Map to [{ fleetId, name }] for filter config
  return (allFleets || []).map((fleet) => ({
    fleetId: fleet.id,
    name: fleet.name,
  }));
}
